import type { MarketplaceIntegrationSpecVersionOut } from '@repo/api-codegen';
import { useMemo } from 'react';

import {
	LastUpdatedRender,
	ReadOnlyBadgeRender,
	TextRender,
} from '../../components/TableV2/render';

import type { ExtendedDataTableColumn } from '../../components/TableV2/types';
import {
	CodeRender,
	TitleWithImageRender,
	VersionActionRender,
} from './MarketplaceIntegrationSpecDetailPage.render';

export const useColumns =
	(): ExtendedDataTableColumn<MarketplaceIntegrationSpecVersionOut>[] => {
		const columns: ExtendedDataTableColumn<MarketplaceIntegrationSpecVersionOut>[] =
			useMemo(
				() => [
					{
						titleLabel: 'Name',
						accessor: 'name',
						render: (record) => <TitleWithImageRender record={record} />,
					},
					{
						titleLabel: 'Version',
						accessor: 'version_number',
						render: (record) => (
							<TextRender<MarketplaceIntegrationSpecVersionOut>
								record={record}
								field={'version_number'}
							/>
						),
					},
					{
						titleLabel: 'Description',
						accessor: 'description',
						render: (record) => (
							<TextRender<MarketplaceIntegrationSpecVersionOut>
								record={record}
								field={'description'}
							/>
						),
					},
					{
						titleLabel: 'Status',
						accessor: 'publish_status',
						render: (record) => (
							<ReadOnlyBadgeRender
								record={record}
								field={'publish_status'}
								options={[
									{
										option: 'draft',
										variant: 'default',
										label: 'Draft',
									},
									{
										option: 'submitted',
										variant: 'warning',
										label: 'In review',
									},
									{
										variant: 'warning',
										label: 'In review',
										option: 'in_review',
									},
									{
										option: 'approved',
										variant: 'success',
										label: 'Approved',
									},
									{
										option: 'published',
										variant: 'success',
										label: 'Published',
									},
									{
										option: 'rejected',
										variant: 'critical',
										label: 'Rejected',
									},
								]}
								nilOption={{
									variant: 'default',
									label: 'Draft',
									option: 'disabled',
								}}
							/>
						),
					},
					{
						titleLabel: 'Code',
						accessor: 'code',
						render: (record) => <CodeRender record={record} />,
						navigate: false,
					},

					{
						titleLabel: 'Action',
						accessor: 'action',
						render: (record) => <VersionActionRender record={record} />,
						navigate: false,
					},
					{
						titleLabel: 'Created at',
						accessor: 'created_at',
						render: (record) => (
							<LastUpdatedRender<MarketplaceIntegrationSpecVersionOut>
								record={record}
								field={'created_at'}
							/>
						),
					},
				],
				[]
			);

		return columns;
	};
